import { CafsType } from "../../../consts/cafsType";
import { VariableRenderProps } from "../../../types/variable-render-props";

export function renderForTree({ cafsType }: VariableRenderProps) {
  return cafsType === CafsType.Tree;
}
